import klarnaIconSvg from './svg/klarnaIcon.svg?url';

export interface IKlarnaIconProps {
	size?: number;
}

export const KlarnaIcon = ({ size = 24 }: IKlarnaIconProps) => {
	return <img src={klarnaIconSvg} alt="Klarna" width={size} height={size} />;
};
